<div id="topicsNavigation">
    <ul class="topics p-0 list-unstyled me-2">
        <h4 class="topic title">
            <a
                class="px-4 py-7"
                queryParamsHandling="merge"
                [ngStyle]="{ 'background-color': colorCode }"
                [routerLink]="activeSubject.getBrowseURL()"
            >
                {{ activeSubject.title }} Topics
            </a>
        </h4>

        <span class="topic-cue">Narrow resources by subtopic</span>

        <li class="topic" *ngFor="let topic of activeSubject.children">
            <a
                *ngIf="topic.resultsCount"
                id="selenium-topic-{{ topic.id }}"
                class="ps-4 pe-2 py-3"
                [ngClass]="{
                    active: activeNode === topic,
                    'ps-8': !topic.children.length,
                }"
                [ngStyle]="{
                    'background-color': activeNode === topic ? colorCode : 'transparent',
                }"
                [routerLink]="topic.getBrowseURL()"
                queryParamsHandling="merge"
            >
                <span *ngIf="topic.children.length" class="me-3">
                    <i class="fas" [ngClass]="getExpandableIcon(topic)"></i>
                </span>
                {{ topic.title }}
            </a>

            <ul class="subtopics me-0 p-0" [ngbCollapse]="topic !== activeTopic">
                <li class="subtopic" *ngFor="let subtopic of topic.children">
                    <a
                        *ngIf="subtopic.resultsCount"
                        id="selenium-subtopic-{{ subtopic.id }}"
                        class="border-0"
                        [ngClass]="{ active: activeNode === subtopic }"
                        [ngStyle]="{
                            'background-color': activeNode === subtopic ? colorCode : 'transparent',
                        }"
                        [routerLink]="subtopic.getBrowseURL()"
                        queryParamsHandling="merge"
                    >
                        {{ subtopic.title }}
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</div>
